<template>
  <div class="computed-parser">
    <span v-if="computedValue" class="result">{{ computedValue }}</span>
<!--    <span class="placeholder" v-else>{{ value.props.placeholder }}</span>-->
    <capital-text
      v-if="value.isCapital"
      :value="computedValue"
      class="capital"
    ></capital-text>
  </div>
</template>

<script>
import { create, all } from "mathjs";
import { flatten } from "../../utils/utils.js";
import CapitalText from "./CapitalText.vue";
const config = {
  number: "BigNumber",
  precision: 1024, // 精度
  // 需要注意的是，计算结果会自动转成科学计数法，大数也会变成小数
  // 因此，这里的精度也会影响大数计算的结果
  // 这里为了尽可能精准，设置了超大的精度，如果影响了性能，请调小精度
};
const math = create(all, config);
export default {
  name: "ComputedParser",
  components: { CapitalText },
  props: {
    value: Object,
    list: Array,
  },
  watch:{
    computedValue(val){
      this.value['computed_value'] = val
    }
  },
  computed: {
    computedValue() {
      const getComputed = (list) => {
        return list.map((ele) => {
          if (/[a-zA-Z]/.test(ele)) {
            const item = flatten(this.list).find((e) => e.id == ele);
            if (item.type == "computed") {
              if (item.id == this.value.id) {
                throw new Error("计算公式存在循环引用，无法计算");
              } else {
                return ["(", getComputed(item.value), ")"];
              }
            } else {
              return item.value;
            }
          }
          return ele;
        });
      };
      let res;
      try {
        res = getComputed(this.value.value);
        while (res.some((e) => Array.isArray(e))) {
          res = res.flat();
        }
        res = res.map(String);
        try {
          return this.toNormalNum(math.evaluate(res.join("")).toString());
        } catch (error) {
          return "";
        }
      } catch (err) {
        console.error(err);
        return err.message;
      }
    },
  },
  methods: {
    toNormalNum(val) {
      // 转成可读性强的数字
      // TODO 不能使用科学计数法，因为科学计数法没办法转成大写
      const [base, power] = val.split("e");
      if (power) {
        const [symbol, ...powerNum] = power;
        return (
          base +
          "×" +
          (symbol == "+"
            ? `10^${powerNum.join("")}`
            : `10^(-${powerNum.join("")})`)
        );
      } else {
        return base;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.computed-parser {
  .result {
    word-break: break-all;
  }

  .placeholder {
    color: lightgray;
    font-size: 14px;
  }
}
</style>